import './index.css';

import App from './App';
import React from 'react';
import {
  BrowserRouter as Router,
} from "react-router-dom";
import ScrollToTop from './helpers/ScrollToTop';
import { Toaster } from 'react-hot-toast';
import { createRoot } from "react-dom/client";
import reportWebVitals from './reportWebVitals';

// Check if deployment status has changed
const currentBuildVersion = '1.0.4'; // Update this when deploying new version
try {
  const storedBuildVersion = localStorage.getItem('buildVersion');
  
  // If the version has changed or doesn't exist yet, clear storage but preserve auth data
  if (!storedBuildVersion || storedBuildVersion !== currentBuildVersion) {
    // Save authentication data before clearing
    const authKeys = [
      'token',
      'logged_user_id',
      'role',
      'user_data',
      'userData',
      'isAuthenticated',
      'chef_id',
      'owner',
      'plan_status',
    ];
    const savedAuthData = {};
    authKeys.forEach(key => {
      savedAuthData[key] = localStorage.getItem(key);
    });
    
    // Clear storage
    localStorage.clear();
    sessionStorage.clear();
    
    // Restore authentication data after clearing
    Object.entries(savedAuthData).forEach(([key, value]) => {
      if (value) localStorage.setItem(key, value);
    });
    
    // Store the current version
    localStorage.setItem('buildVersion', currentBuildVersion);
    ////console.log('Storage cleared due to build version change, auth data preserved');
  }
} catch (error) {
  ////console.error('Error handling storage:', error);
}

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <Router basename='/'>
    <ScrollToTop />
    <Toaster />
    <App />
  </Router>
);
reportWebVitals();



// sudo scp -r ./build/* /var/www/build/
